<div class="account-overview-main-container text">
  <div class="d-flex">
    <account-menu-selection-utils
      [selectedItem]="this.selectedTransType"
      [selectionList]="this.transactionTypes"
      (selectionChange)="this.onTransTypeChange($event)"></account-menu-selection-utils>
    <ng-container [ngSwitch]="['b500', 'terminalPeru'] | getProductName">
      <ng-container *ngSwitchCase="'b500'"></ng-container>
      <ng-container *ngSwitchCase="'terminalPeru'"></ng-container>
      <ng-container *ngSwitchDefault>
        <account-menu-selection-utils
          [selectedItem]="this.selectedSlipDate"
          [selectionList]="this.selectableDate"
          (selectionChange)="this.onBookingDateChange($event)"></account-menu-selection-utils>
      </ng-container>
    </ng-container>
  </div>
  <div class="transaction-history-button text" (click)="transactionHistorySubmit()" *ngIf="this._UserHelper.customerUser?.OldCmbetId != 0">
    {{ 'b3000_transaction_history_text' | t }}
  </div>

  <div class="header-row">
    <div class="header-item">
      {{ 'Date_Time' | t }}
    </div>
    <div class="header-item">
      {{ 'Amount' | t }}
    </div>
    <div class="header-item">
      {{ 'bookings_type' | t }}
    </div>
  </div>
  <div class="content-row" *ngFor="let item of this.bookingsList | sortBy : true : 'TransactionDateISO'; let i = index">
    <div class="content-item">
      {{ item.TransactionDateISO2 | dateFormat : 'dd.MM' }}
      {{ item.TransactionDateISO2 | dateFormat : 'HH:mm' }}
    </div>
    <div class="content-item">{{ item.Amount }} {{ item.Currency }}</div>
    <div class="content-item">{{ item.TransactionType }}</div>
  </div>
</div>
